import * as CubeTree from '../../../cubeTree/index';
import * as Toolkit from '../../../toolkit/index';
import Utils from '../../../utils/util';
import FrontCubeData from '../../../frontCubeData/index';
import Config from '../../../config/index';

const defaultLayerHeight: LogicsicsMeasurement = Toolkit.cmToPx(Config.get({
    moduleName: 'layer',
    key: 'defaultLayerHeight'
}));

// 给层板触发区域加层高
function addLayerHeight(coordinate: CubePaintCoordinate): CubePaintCoordinate {
    let scale: number = Config.get({
        moduleName: 'transform',
        key: 'scale'
    });
    let layerHeight: LogicsicsMeasurement = getLayerHeight(coordinate.id);
    let layerHeightZoom: LogicsicsMeasurement = Utils.math(layerHeight, scale, '*');
    let height: LogicsicsMeasurement = 0;
    let top: LogicsicsMeasurement = 0;

    if (CubeTree.isBeam(coordinate.id)) {
        height = layerHeightZoom;
        top = coordinate.top;
    }
    else {
        height = Utils.math(coordinate.height, layerHeightZoom, '+');
        top = Utils.math(coordinate.top, layerHeightZoom, '-');
    }

    return {
        ...coordinate,
        height,
        top
    };
}

function getLayerHeight(cubeId: CubeId): LogicsicsMeasurement {
    let result: LogicsicsMeasurement = FrontCubeData.getLogicValue(cubeId, 'layerHeight');

    // 最顶部层板，有最小放置区域
    if (!CubeTree.isBeam(cubeId)
        && !CubeTree.isRoof(cubeId)
        && CubeTree.isFirstCube(cubeId)
        && result < 200) {
        result = 200;
    }

    // 最小放置高度为 50
    result = Math.max(result, defaultLayerHeight);

    return result;
}

export {
    addLayerHeight
};
